/**
 * Row data: the Inbox categories (baseline section 5 "Inbox", with A2.1 section 4's SRD source
 * category; 1.0b deliverable 12). Each category is a registered query, not a task table: its
 * owner implements an `InboxCategoryQuery` for it. `subjectKind` names the row an item's
 * `subjectId` points at (`inbox_dismissal.subject_id`); `primaryAction` is the label of the row's
 * one primary action. Pure data (excluded from mutation testing).
 */
/** The rows an Inbox item can be about. */
export const INBOX_SUBJECT_KINDS = [
    'document',
    'capture',
    'link',
    'chron_violation',
    'secret',
    'placement',
    'asset_pending',
    'ai_proposal',
];
export const INBOX_CATEGORIES = [
    {
        key: 'stub',
        label: 'Stubs',
        subjectKind: 'document',
        primaryAction: 'Write it',
        owner: '1.N-3',
        since: 'exit-1b',
    },
    {
        key: 'capture',
        label: 'Captures',
        subjectKind: 'capture',
        primaryAction: 'File it',
        owner: '1.N-3',
        since: 'exit-1b',
    },
    {
        key: 'link_warning',
        label: 'Link warnings',
        subjectKind: 'link',
        primaryAction: 'Review the link',
        owner: '1.N-3',
        since: 'exit-1b',
    },
    {
        key: 'unlinked_mention',
        label: 'Unlinked mentions',
        subjectKind: 'document',
        primaryAction: 'Link',
        owner: '1.N-3',
        since: 'exit-1b',
    },
    {
        key: 'chrono_violation',
        label: 'Chronology violations',
        subjectKind: 'chron_violation',
        primaryAction: 'Resolve',
        owner: '1.N-3',
        since: 'exit-1b',
    },
    {
        key: 'orphaned_secret',
        label: 'Orphaned secrets',
        subjectKind: 'secret',
        primaryAction: 'Re-anchor or retire',
        owner: '1.N-3',
        since: 'exit-1b',
    },
    {
        key: 'lost_anchor',
        label: 'Lost anchors',
        subjectKind: 'placement',
        primaryAction: 'Re-anchor',
        owner: '1.N-3',
        since: 'exit-1b',
    },
    {
        key: 'notion_ref',
        label: 'Notion references',
        subjectKind: 'document',
        primaryAction: 'Resolve the reference',
        owner: '1.N-3',
        since: 'exit-1b',
    },
    {
        key: 'pending_image',
        label: 'Pending images',
        subjectKind: 'asset_pending',
        primaryAction: 'Upload the image',
        owner: '1.N-3',
        since: 'exit-1b',
    },
    {
        key: 'quarantined_value',
        label: 'Quarantined values',
        subjectKind: 'document',
        primaryAction: 'Review the values',
        owner: '1.N-3',
        since: 'exit-1b',
    },
    {
        key: 'srd_source_changed',
        label: 'SRD source changed',
        subjectKind: 'document',
        primaryAction: 'Compare with the SRD',
        owner: '1.AC-1',
        since: 'exit-1b',
    },
    {
        key: 'proposal',
        label: 'Proposals',
        subjectKind: 'ai_proposal',
        primaryAction: 'Review',
        owner: '3.D',
        since: 'exit-3a',
    },
];
//# sourceMappingURL=rows-inbox.js.map